<template>
  <section id="dashboard-ecommerce">
    <b-card no-body>
      <b-card-header>
        <b-card-title class="mb-1">
          Perkin
        </b-card-title>
        <b-card-title
          v-if="$can('Buat', 'perkin')"
          class="text-primary"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            size="sm"
            :to="{ name: 'perkinInput' }"
          >
            <feather-icon
              icon="PlusIcon"
              class="mr-50"
            />
            <span class="align-middle">Input</span>
          </b-button>
        </b-card-title>
      </b-card-header>
      <div class="m-2">
        <b-col
          cols="8"
          offset-md="2"
          class="mb-1"
        >
          <h4>Filter</h4>
          <b-form
            class="needs-validation"
            @submit.prevent="submitFilter"
          >
            <b-row>
              <b-col
                cols="10"
                offset-md="1"
              >
                <b-form-group
                  label="Tahun Pelaksanaan"
                  label-for="tahunFilter"
                >
                  <b-form-select
                    id="tahunFilter"
                    v-model="tahunFilter"
                    :options="dataTahunPelaksanaan"
                    disabled
                  />
                </b-form-group>
                <b-form-group
                  label="Wilayah"
                  label-for="wilayahFilter"
                >
                  <b-form-select
                    id="wilayahFilter"
                    v-model="wilayahFilter"
                    :options="dataWilayah"
                    @change="changeWilayah"
                  />
                </b-form-group>
                <b-form-group
                  label="PD/UPD"
                  label-for="pdUpdFilter"
                >
                  <v-select
                    id="kolok"
                    v-model="pdUpdFilterValue"
                    label="text"
                    :options="dataPdUpd"
                    :disabled="
                      !$can('Filter', 'monitoring') &&
                        !$can('Filter-PdUpd', 'monitoring')
                    "
                    @search="searchPdUpd"
                    @input="inputPdUpd"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-col
              cols="11"
              align="right"
              class="pr-0"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                size="sm"
                type="submit"
              >
                Filter
              </b-button>
            </b-col>
          </b-form>
        </b-col>
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Entri</label>
            <v-select
              v-model="perPageSummary"
              dir="ltr"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
              @input="inputPerPageSummary"
            />
            <div class="align-self-center">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                size="sm"
                class="mr-1"
                @click="clickPrintXl"
              >
                <div v-if="isPrint">
                  <b-spinner small />
                  <span class="sr-only">Loading...</span>
                </div>
                <div v-else>
                  Print Excel
                </div>
              </b-button>
            </div>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-col
                cols="9"
                md="7"
              >
                <b-form-input
                  v-model="searchQueryDashboardSummary"
                  class="d-inline-block mr-1"
                  placeholder="Tekan Enter"
                  @keyup.enter="keyUpSearchDashboardSummary"
                />
              </b-col>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-overlay
        :show="isShowTabel"
        variant="light"
        opacity="0.85"
        blur="2px"
        rounded="sm"
      >
        <b-table
          ref="refInvoiceListTable"
          :items="dataPerkin"
          responsive
          :fields="kolomTw"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
          class="position-relative"
        >
          <!-- Column: tw1 -->
          <template #cell(tw1)="data">
            <b-badge :variant="`light-${data.item.tw1 <= bobotTw1 / 3 ? 'danger' : data.item.tw1 > bobotTw1 / 3 && data.item.tw1 < (bobotTw1 * 2) / 3 ? 'warning' : 'success'}`">
              {{
                data.item.jumlahBmd > 0
                  ? new Intl.NumberFormat("id-ID", {
                    maximumFractionDigits: 2,
                  }).format(data.item.tw1)
                  : "-"
              }}%
            </b-badge>
          </template>

          <!-- Column: tw2 -->
          <template #cell(tw2)="data">
            <b-badge :variant="`light-${data.item.tw2 <= bobotTw2 / 3 ? 'danger' : data.item.tw2 > bobotTw2 / 3 && data.item.tw2 < (bobotTw2 * 2) / 3 ? 'warning' : 'success'}`">
              {{
                data.item.jumlahBmd > 0
                  ? new Intl.NumberFormat("id-ID", {
                    maximumFractionDigits: 2,
                  }).format(data.item.tw2)
                  : "-"
              }}%
            </b-badge>
          </template>

          <!-- Column: tw3 -->
          <template #cell(tw3)="data">
            <b-badge :variant="`light-${data.item.tw3 <= bobotTw3 / 3 ? 'danger' : data.item.tw3 > bobotTw3 / 3 && data.item.tw3 < (bobotTw3 * 2) / 3 ? 'warning' : 'success'}`">
              {{
                data.item.jumlahBmd > 0
                  ? new Intl.NumberFormat("id-ID", {
                    maximumFractionDigits: 2,
                  }).format(data.item.tw3)
                  : "-"
              }}%
            </b-badge>
          </template>

          <!-- Column: tw4 -->
          <template #cell(tw4)="data">
            <b-badge :variant="`light-${
                data.item.tw4 <= bobotTw4 / 3
                  ? 'danger'
                  : data.item.tw4 > bobotTw4 / 3 &&
                    data.item.tw4 < (bobotTw4 * 2) / 3
                    ? 'warning'
                    : 'success'
              }`">
              {{
                data.item.jumlahBmd > 0
                  ? new Intl.NumberFormat("id-ID", {
                    maximumFractionDigits: 2,
                  }).format(data.item.tw4)
                  : "-"
              }}%
            </b-badge>
          </template>

          <template #cell(collapse)="row">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              class="btn-icon"
              size="sm"
              @click="clickCollapse(row)"
            >
              <feather-icon :icon="
                  row.detailsShowing ? 'ChevronDownIcon' : 'ChevronRightIcon'
                " />
            </b-button>
          </template>

          <template #row-details="row">
            <b-card>
              <h6 class="font-weight-bolder">
                Individu
              </h6>
              <b-table-simple
                hover
                responsive
              >
                <b-thead>
                  <b-tr style="border-style: solid">
                    <b-th colspan="2">
                      Kegiatan
                    </b-th>
                    <b-th>
                      TW1
                      <b-badge variant="light-danger">
                        {{ bobotTw1Show }}
                      </b-badge>
                    </b-th>
                    <b-th>
                      TW2
                      <b-badge variant="light-warning">
                        {{ bobotTw2Show }}
                      </b-badge>
                    </b-th>
                    <b-th>
                      TW3
                      <b-badge variant="light-success">
                        {{ bobotTw3Show }}
                      </b-badge>
                    </b-th>
                    <b-th>
                      TW4<b-badge variant="light-success">
                        {{ bobotTw4Show }}
                      </b-badge>
                    </b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr style="border-style: solid; border-bottom: none">
                    <b-td rowspan="2">
                      Persiapan
                      <b-badge variant="light-success">
                        10%
                      </b-badge>
                    </b-td>
                    <b-td>Tim</b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.persiapanTimTw1 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.persiapanTimTw1 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.persiapanTimTw2 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.persiapanTimTw2 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.persiapanTimTw3 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.persiapanTimTw3 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.persiapanTimTw4 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.persiapanTimTw4 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                  </b-tr>
                  <b-tr style="border-style: solid; border-top: none">
                    <b-td>Jadwal</b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.persiapanJadwalTw1 == 1
                            ? 'success'
                            : 'danger'
                        }`">
                        {{ row.item.persiapanJadwalTw1 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.persiapanJadwalTw2 == 1
                            ? 'success'
                            : 'danger'
                        }`">{{ row.item.persiapanJadwalTw2 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.persiapanJadwalTw3 == 1
                            ? 'success'
                            : 'danger'
                        }`">{{ row.item.persiapanJadwalTw3 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.persiapanJadwalTw4 == 1
                            ? 'success'
                            : 'danger'
                        }`">{{ row.item.persiapanJadwalTw4 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                  </b-tr>
                  <b-tr style="border-style: solid; border-bottom: none">
                    <b-td rowspan="2">
                      Pelaksanaan
                      <b-badge variant="light-success">
                        75%
                      </b-badge>
                    </b-td>
                    <b-td>
                      Selesai Inventarisasi/Total BMD
                      <small>
                        <b-badge variant="light-secondary">
                          tidak diakumulasi
                        </b-badge>
                      </small>
                    </b-td>
                    <b-td>
                      {{ `${row.item.hasilSensusTw1}/${row.item.jumlahBmd}` }}
                      <b-badge :variant="`light-${
                          (row.item.hasilSensusTw1 / row.item.jumlahBmd) *
                          100 <=
                          33
                            ? 'danger'
                            : (row.item.hasilSensusTw1 / row.item.jumlahBmd) *
                              100 >
                              33 &&
                              (row.item.hasilSensusTw1 / row.item.jumlahBmd) *
                              100 <
                              66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          row.item.jumlahBmd > 0
                            ? new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(
                              (row.item.hasilSensusTw1 / row.item.jumlahBmd) *
                                100
                            )
                            : "-"
                        }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      {{ `${row.item.hasilSensusTw2}/${row.item.jumlahBmd}` }}
                      <b-badge :variant="`light-${
                          (row.item.hasilSensusTw2 / row.item.jumlahBmd) *
                          100 <=
                          33
                            ? 'danger'
                            : (row.item.hasilSensusTw2 / row.item.jumlahBmd) *
                              100 >
                              33 &&
                              (row.item.hasilSensusTw2 / row.item.jumlahBmd) *
                              100 <
                              66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          row.item.jumlahBmd > 0
                            ? new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(
                              (row.item.hasilSensusTw2 / row.item.jumlahBmd) *
                                100
                            )
                            : "-"
                        }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      {{ `${row.item.hasilSensusTw3}/${row.item.jumlahBmd}` }}
                      <b-badge :variant="`light-${
                          (row.item.hasilSensusTw3 / row.item.jumlahBmd) *
                          100 <=
                          33
                            ? 'danger'
                            : (row.item.hasilSensusTw3 / row.item.jumlahBmd) *
                              100 >
                              33 &&
                              (row.item.hasilSensusTw3 / row.item.jumlahBmd) *
                              100 <
                              66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          row.item.jumlahBmd > 0
                            ? new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(
                              (row.item.hasilSensusTw3 / row.item.jumlahBmd) *
                                100
                            )
                            : "-"
                        }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      {{ `${row.item.hasilSensusTw4}/${row.item.jumlahBmd}` }}
                      <b-badge :variant="`light-${
                          (row.item.hasilSensusTw4 / row.item.jumlahBmd) *
                          100 <=
                          33
                            ? 'danger'
                            : (row.item.hasilSensusTw4 / row.item.jumlahBmd) *
                              100 >
                              33 &&
                              (row.item.hasilSensusTw4 / row.item.jumlahBmd) *
                              100 <
                              66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          row.item.jumlahBmd > 0
                            ? new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(
                              (row.item.hasilSensusTw4 / row.item.jumlahBmd) *
                                100
                            )
                            : "-"
                        }}%
                      </b-badge>
                    </b-td>
                  </b-tr>
                  <b-tr style="border-style: solid; border-top: none">
                    <b-td>Dari bobot</b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          (row.item.hasilSensusTw1 / row.item.jumlahBmd) *
                          100 <=
                          33
                            ? 'danger'
                            : (row.item.hasilSensusTw1 / row.item.jumlahBmd) *
                              100 >
                              33 &&
                              (row.item.hasilSensusTw1 / row.item.jumlahBmd) *
                              100 <
                              66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          row.item.jumlahBmd > 0
                            ? new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(
                              (row.item.hasilSensusTw1 / row.item.jumlahBmd) *
                                75
                            )
                            : "-"
                        }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          (row.item.hasilSensusTw2 / row.item.jumlahBmd) *
                          100 <=
                          33
                            ? 'danger'
                            : (row.item.hasilSensusTw2 / row.item.jumlahBmd) *
                              100 >
                              33 &&
                              (row.item.hasilSensusTw2 / row.item.jumlahBmd) *
                              100 <
                              66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          row.item.jumlahBmd > 0
                            ? new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(
                              (row.item.hasilSensusTw2 / row.item.jumlahBmd) *
                                75
                            )
                            : "-"
                        }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          (row.item.hasilSensusTw3 / row.item.jumlahBmd) *
                          100 <=
                          33
                            ? 'danger'
                            : (row.item.hasilSensusTw3 / row.item.jumlahBmd) *
                              100 >
                              33 &&
                              (row.item.hasilSensusTw3 / row.item.jumlahBmd) *
                              100 <
                              66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          row.item.jumlahBmd > 0
                            ? new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(
                              (row.item.hasilSensusTw3 / row.item.jumlahBmd) *
                                75
                            )
                            : "-"
                        }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          (row.item.hasilSensusTw4 / row.item.jumlahBmd) *
                          100 <=
                          33
                            ? 'danger'
                            : (row.item.hasilSensusTw4 / row.item.jumlahBmd) *
                              100 >
                              33 &&
                              (row.item.hasilSensusTw4 / row.item.jumlahBmd) *
                              100 <
                              66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          row.item.jumlahBmd > 0
                            ? new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(
                              (row.item.hasilSensusTw4 / row.item.jumlahBmd) *
                                75
                            )
                            : "-"
                        }}%
                      </b-badge>
                    </b-td>
                  </b-tr>
                  <b-tr style="border-style: solid; border-bottom: none">
                    <b-td rowspan="3">Pelaporan
                      <b-badge variant="light-success">
                        15%
                      </b-badge>
                    </b-td>
                    <b-td>SPTJM</b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.pelaporanSptjmTw1 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.pelaporanSptjmTw1 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.pelaporanSptjmTw2 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.pelaporanSptjmTw2 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.pelaporanSptjmTw3 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.pelaporanSptjmTw3 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.pelaporanSptjmTw4 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.pelaporanSptjmTw4 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                  </b-tr>
                  <b-tr style="
                      border-style: solid;
                      border-bottom: none;
                      border-top: none;
                    ">
                    <b-td>Berita Acara</b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.pelaporanBaTw1 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.pelaporanBaTw1 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.pelaporanBaTw2 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.pelaporanBaTw2 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.pelaporanBaTw3 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.pelaporanBaTw3 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.pelaporanBaTw4 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.pelaporanBaTw4 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                  </b-tr>
                  <b-tr style="border-style: solid; border-top: none">
                    <b-td>Laporan</b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.pelaporanLhTw1 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.pelaporanLhTw1 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.pelaporanLhTw2 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.pelaporanLhTw2 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.pelaporanLhTw3 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.pelaporanLhTw3 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.pelaporanLhTw4 == 1 ? 'success' : 'danger'
                        }`">
                        {{ row.item.pelaporanLhTw4 == 1 ? 5 : 0 }}%
                      </b-badge>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tfoot>
                  <b-tr
                    variant="secondary"
                    style="border-style: solid"
                  >
                    <b-td colspan="2">
                      Akumulasi Pembobotan
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.tw1 <= 33
                            ? 'danger'
                            : row.item.tw1 > 33 && row.item.tw1 < 66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          isNaN(row.item.tw1)
                            ? "-"
                            : new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(row.item.tw1)
                        }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.tw2 <= 33
                            ? 'danger'
                            : row.item.tw2 > 33 && row.item.tw2 < 66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          isNaN(row.item.tw2)
                            ? "-"
                            : new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(row.item.tw2)
                        }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.tw3 <= 33
                            ? 'danger'
                            : row.item.tw3 > 33 && row.item.tw3 < 66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          isNaN(row.item.tw3)
                            ? "-"
                            : new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(row.item.tw3)
                        }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.tw4 <= 33
                            ? 'danger'
                            : row.item.tw4 > 33 && row.item.tw4 < 66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          isNaN(row.item.tw4)
                            ? "-"
                            : new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(row.item.tw4)
                        }}%
                      </b-badge>
                    </b-td>
                  </b-tr>
                  <b-tr
                    variant="secondary"
                    style="border-style: solid"
                  >
                    <b-td colspan="2">
                      Akumulasi Per TW
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.tw1Bobot <= 33
                            ? 'danger'
                            : row.item.tw1Bobot > 33 && row.item.tw1Bobot < 66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          isNaN(row.item.tw1Bobot)
                            ? "-"
                            : new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(row.item.tw1Bobot)
                        }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.tw2Bobot <= 33
                            ? 'danger'
                            : row.item.tw2Bobot > 33 && row.item.tw2Bobot < 66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          isNaN(row.item.tw2Bobot)
                            ? "-"
                            : new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(row.item.tw2Bobot)
                        }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.tw3Bobot <= 33
                            ? 'danger'
                            : row.item.tw3Bobot > 33 && row.item.tw3Bobot < 66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          isNaN(row.item.tw3Bobot)
                            ? "-"
                            : new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(row.item.tw3Bobot)
                        }}%
                      </b-badge>
                    </b-td>
                    <b-td>
                      <b-badge :variant="`light-${
                          row.item.tw4Bobot <= 33
                            ? 'danger'
                            : row.item.tw4Bobot > 33 && row.item.tw4Bobot < 66
                              ? 'warning'
                              : 'success'
                        }`">
                        {{
                          isNaN(row.item.tw4Bobot)
                            ? "-"
                            : new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(row.item.tw4Bobot)
                        }}%
                      </b-badge>
                    </b-td>
                  </b-tr>
                </b-tfoot>
              </b-table-simple>

              <div v-if="row.item.isParent">
                <h6 class="pt-1 font-weight-bolder">
                  Gabungan
                </h6>
                <b-table-simple
                  hover
                  responsive
                >
                  <b-thead>
                    <b-tr style="border-style: solid">
                      <b-th colspan="2">
                        Kegiatan
                      </b-th>
                      <b-th>
                        TW1
                        <b-badge variant="light-danger">
                          {{ bobotTw1Show }}
                        </b-badge>
                      </b-th>
                      <b-th>
                        TW2
                        <b-badge variant="light-warning">
                          {{ bobotTw2Show }}
                        </b-badge>
                      </b-th>
                      <b-th>
                        TW3
                        <b-badge variant="light-success">
                          {{ bobotTw3Show }}
                        </b-badge>
                      </b-th>
                      <b-th>
                        TW4<b-badge variant="light-success">
                          {{ bobotTw4Show }}
                        </b-badge>
                      </b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr style="border-style: solid; border-bottom: none">
                      <b-td rowspan="2">
                        Persiapan
                        <b-badge variant="light-success">
                          10%
                        </b-badge></b-td>
                      <b-td>Tim</b-td>
                      <b-td
                        v-for="(item, index) of row.item.gabungan.persiapan.tim"
                        :key="index"
                      >
                        <b-badge :variant="`light-${
                            item <= 1.66
                              ? 'danger'
                              : item > 1.66 && item < 3.32
                                ? 'warning'
                                : 'success'
                          }`">
                          {{
                            new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(item)
                          }}%
                        </b-badge>
                      </b-td>
                    </b-tr>
                    <b-tr style="border-style: solid; border-top: none">
                      <b-td>Jadwal</b-td>
                      <b-td
                        v-for="(item, index) of row.item.gabungan.persiapan
                          .jadwal"
                        :key="index"
                      >
                        <b-badge :variant="`light-${
                            item <= 1.66
                              ? 'danger'
                              : item > 1.66 && item < 3.32
                                ? 'warning'
                                : 'success'
                          }`">
                          {{
                            new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(item)
                          }}%
                        </b-badge>
                      </b-td>
                    </b-tr>
                    <b-tr style="border-style: solid; border-bottom: none">
                      <b-td rowspan="2">
                        Pelaksanaan
                        <b-badge variant="light-success">
                          75%
                        </b-badge>
                      </b-td>
                      <b-td>
                        Selesai Inventarisasi/Total BMD
                        <small>
                          <b-badge variant="light-secondary">
                            tidak diakumulasi
                          </b-badge>
                        </small>
                      </b-td>
                      <b-td
                        v-for="(item, index) of row.item.gabungan.pelaksanaan
                          .selesai"
                        :key="index"
                      >
                        {{
                          `${numThousand(item)}/${numThousand(
                            row.item.gabungan.pelaksanaan.jumlahBmd
                          )}`
                        }}
                        <b-badge :variant="`light-${
                            (item / row.item.gabungan.pelaksanaan.jumlahBmd) *
                            100 <=
                            33
                              ? 'danger'
                              : (item /
                                row.item.gabungan.pelaksanaan.jumlahBmd) *
                                100 >
                                33 &&
                                (item /
                                  row.item.gabungan.pelaksanaan.jumlahBmd) *
                                100 <
                                66
                                ? 'warning'
                                : 'success'
                          }`">
                          {{
                            new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(
                              (item / row.item.gabungan.pelaksanaan.jumlahBmd) *
                                100
                            )
                          }}%
                        </b-badge>
                      </b-td>
                    </b-tr>
                    <b-tr style="border-style: solid; border-top: none">
                      <b-td>Dari bobot</b-td>
                      <b-td
                        v-for="(item, index) of row.item.gabungan.pelaksanaan
                          .bobot"
                        :key="index"
                      >
                        <b-badge :variant="`light-${
                            item <= 25
                              ? 'danger'
                              : item > 25 && item < 50
                                ? 'warning'
                                : 'success'
                          }`">
                          {{
                            new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(item)
                          }}%
                        </b-badge>
                      </b-td>
                    </b-tr>
                    <b-tr style="border-style: solid; border-bottom: none">
                      <b-td rowspan="3">Pelaporan
                        <b-badge variant="light-success">
                          15%
                        </b-badge>
                      </b-td>
                      <b-td>SPTJM</b-td>
                      <b-td
                        v-for="(item, index) of row.item.gabungan.pelaporan
                          .sptjm"
                        :key="index"
                      >
                        <b-badge :variant="`light-${
                            item <= 1.66
                              ? 'danger'
                              : item > 1.66 && item < 3.32
                                ? 'warning'
                                : 'success'
                          }`">
                          {{
                            new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(item)
                          }}%
                        </b-badge>
                      </b-td>
                    </b-tr>
                    <b-tr style="
                        border-style: solid;
                        border-bottom: none;
                        border-top: none;
                      ">
                      <b-td>Berita Acara</b-td>
                      <b-td
                        v-for="(item, index) of row.item.gabungan.pelaporan
                          .beritaAcara"
                        :key="index"
                      >
                        <b-badge :variant="`light-${
                            item <= 1.66
                              ? 'danger'
                              : item > 1.66 && item < 3.32
                                ? 'warning'
                                : 'success'
                          }`">
                          {{
                            new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(item)
                          }}%
                        </b-badge>
                      </b-td>
                    </b-tr>
                    <b-tr style="border-style: solid; border-top: none">
                      <b-td>Laporan</b-td>
                      <b-td
                        v-for="(item, index) of row.item.gabungan.pelaporan
                          .laporan"
                        :key="index"
                      >
                        <b-badge :variant="`light-${
                            item <= 1.66
                              ? 'danger'
                              : item > 1.66 && item < 3.32
                                ? 'warning'
                                : 'success'
                          }`">
                          {{
                            new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(item)
                          }}%
                        </b-badge>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                  <b-tfoot>
                    <b-tr
                      variant="secondary"
                      style="border-style: solid"
                    >
                      <b-td colspan="2">
                        Akumulasi Pembobotan
                      </b-td>
                      <b-td
                        v-for="(item, index) of row.item.gabungan.akumulasi"
                        :key="index"
                      >
                        <b-badge :variant="`light-${
                            item <= 33
                              ? 'danger'
                              : item > 33 && item < 66
                                ? 'warning'
                                : 'success'
                          }`">
                          {{
                            new Intl.NumberFormat("id-ID", {
                              maximumFractionDigits: 2,
                            }).format(item)
                          }}%
                        </b-badge>
                      </b-td>
                    </b-tr>
                    <b-tr
                      variant="secondary"
                      style="border-style: solid"
                    >
                      <b-td colspan="2">
                        Akumulasi Per TW
                      </b-td>
                      <b-td
                        v-for="(item, index) of row.item.gabungan.akumulasi2"
                        :key="index"
                      >
                        <b-badge :variant="`light-${
                            item <= 33
                              ? 'danger'
                              : item > 33 && item < 66
                                ? 'warning'
                                : 'success'
                          }`">
                          {{
                            isNaN(item)
                              ? "-"
                              : new Intl.NumberFormat("id-ID", {
                                maximumFractionDigits: 2,
                              }).format(item)
                          }}%
                        </b-badge>
                      </b-td>
                    </b-tr>
                  </b-tfoot>
                </b-table-simple>
              </div>
            </b-card>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Menampilkan
                {{ (currentPageSummary - 1) * perPageSummary + 1 }} hingga
                {{ currentPageSummary * perPageSummary }} dari
                {{ totalRecordsDashboardSummary }} entri</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPageSummary"
                :total-rows="totalRecordsDashboardSummary"
                :per-page="perPageSummary"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @input="changePageSummary"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BButton,
  BForm,
  BFormGroup,
  BFormSelect,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import VueApexCharts from 'vue-apexcharts'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import moment from 'moment'
import { utils, writeFileXLSX } from 'xlsx'
import master from '@/composables/master'
import apiPerkin from '@/composables/perkin'
import { generateYears, startYear, intThousand } from '@/libs/helper'

const { showError } = require('@/libs/helper')

export default {
  setup(props, context) {
    // global variable
    const g = context.root
    const { $route } = g

    const year = moment().format('YYYY')
    const isLoadingChart = ref(false)
    const isPrint = ref(false)

    const pdUpdFilter = ref($route.query['pd-upd'] || '')
    const pdUpdFilterValue = ref({ text: '-- Semua --', value: '' })
    const wilayahFilter = ref($route.query.wilayah || '')
    const tahunFilter = ref($route.query.tahun || year)
    const dataPie = ref([])
    const dataCapaianInventarisasi = ref([])
    const isShowTabel = ref(true)

    const cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))

    if (cookiesJenisAkun.value == 'D' || cookiesJenisAkun.value == 'F') {
      const cookiesNalok = ref(g.$cookies.get('nalok'))
      const cookiesKolok = ref(g.$cookies.get('kolok'))
      const cookiesWilayah = ref(g.$cookies.get('wilayah'))
      pdUpdFilterValue.value = {
        text: `${cookiesKolok.value}::${cookiesNalok.value}`,
        value: cookiesKolok.value,
      }
      pdUpdFilter.value = cookiesKolok.value
      wilayahFilter.value = cookiesWilayah.value
    } else if (cookiesJenisAkun.value == 'pelaksana-suban') { wilayahFilter.value = parseInt(g.$cookies.get('wilayah'), 10) }

    const perPage = ref(10)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const statusFilter = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const rows = ref([])

    const perPageSummary = ref(10)
    const totalRecordsDashboardSummary = ref(0)
    const searchQueryDashboardSummary = ref('')
    const dataPerkin = ref([])
    const currentPageSummary = ref(1)

    const bobotTw1 = ref(0)
    const bobotTw2 = ref(10)
    const bobotTw3 = ref(55)
    const bobotTw4 = ref(100)
    const bobotTw1Show = ref('N/A')
    const bobotTw2Show = ref('10%')
    const bobotTw3Show = ref('55%')
    const bobotTw4Show = ref('100%')

    const pieChart = ref(null)

    const dataStatus = ref([{ value: '', text: '-- Semua --' }])

    const dataWilayah = ref([])
    const dataPdUpd = ref([{ text: '-- Semua --', value: '' }])
    const tempListYear = generateYears(startYear, year)
    tempListYear.unshift({
      text: '--Semua--',
      value: '',
    })
    const dataTahunPelaksanaan = ref(tempListYear)

    const kolomTw = [
      { key: 'collapse', label: '' },
      { key: 'kolok' },
      { key: 'nalok' },
      { key: 'tw1', label: `TW1 (${bobotTw1Show.value})` },
      { key: 'tw2', label: `TW2 (${bobotTw2Show.value})` },
      {
        key: 'tw3',
        label: `TW3 (${bobotTw3Show.value})`,
      },
      {
        key: 'tw4',
        label: `TW4 (${bobotTw4Show.value})`,
      },
    ]

    const kolomDetailPerkin = ref([
      'kegiatan',
      {
        key: 'tw1',
        label: `TW1 (${bobotTw1Show.value})`,
      },
      {
        key: 'tw2',
        label: `TW2 (${bobotTw2Show.value})`,
      },
      {
        key: 'tw3',
        label: `TW3 (${bobotTw3Show.value})`,
      },
      {
        key: 'tw4',
        label: `TW4 (${bobotTw4Show.value})`,
      },
    ])

    const dataSummary = async () => {
      isShowTabel.value = true

      const params = {
        filter_ukpd: pdUpdFilter.value,
        length: perPageSummary.value,
        start: (currentPageSummary.value - 1) * perPageSummary.value,
        search: searchQueryDashboardSummary.value,
        kode_wilayah: wilayahFilter.value,
      }
      const resPerkin = await apiPerkin.getListPerkin(g, params)
      const { code, data, totalData } = resPerkin

      if (code == 200) {
        let tw1 = 0
        let tw2 = 0
        let tw3 = 0
        let tw4 = 0

        dataPerkin.value = data.map(item => {
          tw1 = 0
          tw2 = 0
          tw3 = 0
          tw4 = 0

          if (item.persiapanTimTw1 == 1) tw1 += 5
          if (item.persiapanTimTw2 == 1) tw2 += 5
          if (item.persiapanTimTw3 == 1) tw3 += 5
          if (item.persiapanTimTw4 == 1) tw4 += 5

          if (item.persiapanJadwalTw1 == 1) tw1 += 5
          if (item.persiapanJadwalTw2 == 1) tw2 += 5
          if (item.persiapanJadwalTw3 == 1) tw3 += 5
          if (item.persiapanJadwalTw4 == 1) tw4 += 5

          tw1 += (item.hasilSensusTw1 / item.jumlahBmd) * 75
          tw2 += (item.hasilSensusTw2 / item.jumlahBmd) * 75
          tw3 += (item.hasilSensusTw3 / item.jumlahBmd) * 75
          tw4 += (item.hasilSensusTw4 / item.jumlahBmd) * 75

          if (item.pelaporanBaTw1 == 1) tw1 += 5
          if (item.pelaporanBaTw2 == 1) tw2 += 5
          if (item.pelaporanBaTw3 == 1) tw3 += 5
          if (item.pelaporanBaTw4 == 1) tw4 += 5

          if (item.pelaporanSptjmTw1 == 1) tw1 += 5
          if (item.pelaporanSptjmTw2 == 1) tw2 += 5
          if (item.pelaporanSptjmTw3 == 1) tw3 += 5
          if (item.pelaporanSptjmTw4 == 1) tw4 += 5

          if (item.pelaporanLhTw1 == 1) tw1 += 5
          if (item.pelaporanLhTw2 == 1) tw2 += 5
          if (item.pelaporanLhTw3 == 1) tw3 += 5
          if (item.pelaporanLhTw4 == 1) tw4 += 5

          return {
            kolok: item.kolok,
            nalok: item.nalok,
            tw1,
            tw2,
            tw3,
            tw4,
            isParent: item.tipeKolok == 'SKPD',
            ...item,
            tw1Bobot: bobotTw1.value ? (tw1 / bobotTw1.value) * 100 : '-',
            tw2Bobot: bobotTw2.value ? (tw2 / bobotTw2.value) * 100 : '-',
            tw3Bobot: bobotTw3.value ? (tw3 / bobotTw3.value) * 100 : '-',
            tw4Bobot: bobotTw4.value ? (tw4 / bobotTw4.value) * 100 : '-',
          }
        })
        totalRecordsDashboardSummary.value = totalData
      } else {
        dataPerkin.value = []
        totalRecordsDashboardSummary.value = 0
      }

      isShowTabel.value = false
    }

    const submitFilter = () => {
      const url = `?wilayah=${wilayahFilter.value}&tahun=${tahunFilter.value}&pd-upd=${pdUpdFilter.value}`
      window.history.pushState('', '', url)
      dataSummary()
    }

    const getStatus = async () => {
      let tempStatus = [{ text: '-- Semua --', value: '' }]
      let resStatus = await master.getStatus(g)
      tempStatus = [...tempStatus, ...resStatus.data]

      const params = {
        list: 'unfound',
      }
      resStatus = await master.getStatus(g, params)
      tempStatus = [...tempStatus, ...resStatus.data]

      dataStatus.value = tempStatus
    }

    const getWilayah = async () => {
      const resWilayah = await master.getWilayah(g)
      resWilayah.unshift({ text: '-- Semua --', value: '' })

      dataWilayah.value = resWilayah
    }

    const getPdUpd = async (searchPdUpd = '') => {
      const params = {
        tahun: tahunFilter.value,
        cari: searchPdUpd,
        wilayah: wilayahFilter.value,
      }
      const resPdUpd = await master.getPdUpd(g, params)
      resPdUpd.unshift({ text: '-- Semua --', value: '' })
      dataPdUpd.value = resPdUpd
    }

    const keyUpSearchDashboardSummary = () => {
      currentPageSummary.value = 1
      dataSummary()
    }

    const inputPerPageSummary = () => {
      dataSummary()
    }

    const changePageSummary = () => {
      dataSummary()
    }

    const searchPdUpd = async search => {
      getPdUpd(search)
    }

    const changeWilayah = () => {
      if (cookiesJenisAkun.value != 'D' && cookiesJenisAkun.value != 'F') {
        pdUpdFilterValue.value = { text: '-- Semua --', value: '' }
        pdUpdFilter.value = ''
      }
      getPdUpd()
    }

    const inputPdUpd = () => {
      if (pdUpdFilterValue.value) { pdUpdFilter.value = pdUpdFilterValue.value.value }
    }

    const clickCollapse = async item => {
      if (
        !dataPerkin.value[item.index].details
        && dataPerkin.value[item.index].isParent
      ) {
        const params = {
          filter_upd: item.item.kolok,
          length: 10000,
          start: 0,
        }
        const resPerkin = await apiPerkin.getListPerkin(g, params)
        const { code, data, totalData } = resPerkin

        if (code == 200) {
          let persiapanTimTw1 = 0
          let persiapanTimTw2 = 0
          let persiapanTimTw3 = 0
          let persiapanTimTw4 = 0

          let persiapanJadwalTw1 = 0
          let persiapanJadwalTw2 = 0
          let persiapanJadwalTw3 = 0
          let persiapanJadwalTw4 = 0

          let pelaksanaanSelesaiTw1 = 0
          let pelaksanaanSelesaiTw2 = 0
          let pelaksanaanSelesaiTw3 = 0
          let pelaksanaanSelesaiTw4 = 0

          let pelaksanaanBobotTw1 = 0
          let pelaksanaanBobotTw2 = 0
          let pelaksanaanBobotTw3 = 0
          let pelaksanaanBobotTw4 = 0

          let jumlahBmd = 0

          let pelaporanBaTw1 = 0
          let pelaporanBaTw2 = 0
          let pelaporanBaTw3 = 0
          let pelaporanBaTw4 = 0

          let pelaporanSptjmTw1 = 0
          let pelaporanSptjmTw2 = 0
          let pelaporanSptjmTw3 = 0
          let pelaporanSptjmTw4 = 0

          let pelaporanLhTw1 = 0
          let pelaporanLhTw2 = 0
          let pelaporanLhTw3 = 0
          let pelaporanLhTw4 = 0

          let tw1 = 0
          let tw2 = 0
          let tw3 = 0
          let tw4 = 0

          for (let i = 0; i < data.length; i++) {
            const item = data[i]
            if (item.persiapanTimTw1 == 1) persiapanTimTw1 += 5
            if (item.persiapanTimTw2 == 1) persiapanTimTw2 += 5
            if (item.persiapanTimTw3 == 1) persiapanTimTw3 += 5
            if (item.persiapanTimTw4 == 1) persiapanTimTw4 += 5

            if (item.persiapanJadwalTw1 == 1) persiapanJadwalTw1 += 5
            if (item.persiapanJadwalTw2 == 1) persiapanJadwalTw2 += 5
            if (item.persiapanJadwalTw3 == 1) persiapanJadwalTw3 += 5
            if (item.persiapanJadwalTw4 == 1) persiapanJadwalTw4 += 5

            pelaksanaanSelesaiTw1 += parseInt(item.hasilSensusTw1)
            pelaksanaanSelesaiTw2 += parseInt(item.hasilSensusTw2)
            pelaksanaanSelesaiTw3 += parseInt(item.hasilSensusTw3)
            pelaksanaanSelesaiTw4 += parseInt(item.hasilSensusTw4)

            jumlahBmd += parseInt(item.jumlahBmd)

            if (item.pelaporanBaTw1 == 1) pelaporanBaTw1 += 5
            if (item.pelaporanBaTw2 == 1) pelaporanBaTw2 += 5
            if (item.pelaporanBaTw3 == 1) pelaporanBaTw3 += 5
            if (item.pelaporanBaTw4 == 1) pelaporanBaTw4 += 5

            if (item.pelaporanSptjmTw1 == 1) pelaporanSptjmTw1 += 5
            if (item.pelaporanSptjmTw2 == 1) pelaporanSptjmTw2 += 5
            if (item.pelaporanSptjmTw3 == 1) pelaporanSptjmTw3 += 5
            if (item.pelaporanSptjmTw4 == 1) pelaporanSptjmTw4 += 5

            if (item.pelaporanLhTw1 == 1) pelaporanLhTw1 += 5
            if (item.pelaporanLhTw2 == 1) pelaporanLhTw2 += 5
            if (item.pelaporanLhTw3 == 1) pelaporanLhTw3 += 5
            if (item.pelaporanLhTw4 == 1) pelaporanLhTw4 += 5
          }

          persiapanTimTw1 /= totalData
          persiapanTimTw2 /= totalData
          persiapanTimTw3 /= totalData
          persiapanTimTw4 /= totalData

          persiapanJadwalTw1 /= totalData
          persiapanJadwalTw2 /= totalData
          persiapanJadwalTw3 /= totalData
          persiapanJadwalTw4 /= totalData

          pelaksanaanBobotTw1 = (pelaksanaanSelesaiTw1 / jumlahBmd) * 75
          pelaksanaanBobotTw2 = (pelaksanaanSelesaiTw2 / jumlahBmd) * 75
          pelaksanaanBobotTw3 = (pelaksanaanSelesaiTw3 / jumlahBmd) * 75
          pelaksanaanBobotTw4 = (pelaksanaanSelesaiTw4 / jumlahBmd) * 75

          pelaporanBaTw1 /= totalData
          pelaporanBaTw2 /= totalData
          pelaporanBaTw3 /= totalData
          pelaporanBaTw4 /= totalData

          pelaporanSptjmTw1 /= totalData
          pelaporanSptjmTw2 /= totalData
          pelaporanSptjmTw3 /= totalData
          pelaporanSptjmTw4 /= totalData

          pelaporanLhTw1 /= totalData
          pelaporanLhTw2 /= totalData
          pelaporanLhTw3 /= totalData
          pelaporanLhTw4 /= totalData

          tw1 = Math.round(
            persiapanTimTw1
              + persiapanJadwalTw1
              + pelaksanaanBobotTw1
              + pelaporanBaTw1
              + pelaporanSptjmTw1
              + pelaporanLhTw1,
          )
          tw2 = Math.round(
            persiapanTimTw2
              + persiapanJadwalTw2
              + pelaksanaanBobotTw2
              + pelaporanBaTw2
              + pelaporanSptjmTw2
              + pelaporanLhTw2,
          )
          tw3 = Math.round(
            persiapanTimTw3
              + persiapanJadwalTw3
              + pelaksanaanBobotTw3
              + pelaporanBaTw3
              + pelaporanSptjmTw3
              + pelaporanLhTw3,
          )
          tw4 = Math.round(
            persiapanTimTw4
              + persiapanJadwalTw4
              + pelaksanaanBobotTw4
              + pelaporanBaTw4
              + pelaporanSptjmTw4
              + pelaporanLhTw4,
          )

          dataPerkin.value[item.index].gabungan = {
            persiapan: {
              tim: [
                persiapanTimTw1,
                persiapanTimTw2,
                persiapanTimTw3,
                persiapanTimTw4,
              ],
              jadwal: [
                persiapanJadwalTw1,
                persiapanJadwalTw2,
                persiapanJadwalTw3,
                persiapanJadwalTw4,
              ],
            },
            pelaksanaan: {
              selesai: [
                pelaksanaanSelesaiTw1,
                pelaksanaanSelesaiTw2,
                pelaksanaanSelesaiTw3,
                pelaksanaanSelesaiTw4,
              ],
              bobot: [
                pelaksanaanBobotTw1,
                pelaksanaanBobotTw2,
                pelaksanaanBobotTw3,
                pelaksanaanBobotTw4,
              ],
              jumlahBmd,
            },
            pelaporan: {
              beritaAcara: [
                pelaporanBaTw1,
                pelaporanBaTw2,
                pelaporanBaTw3,
                pelaporanBaTw4,
              ],
              sptjm: [
                pelaporanSptjmTw1,
                pelaporanSptjmTw2,
                pelaporanSptjmTw3,
                pelaporanSptjmTw4,
              ],
              laporan: [
                pelaporanLhTw1,
                pelaporanLhTw2,
                pelaporanLhTw3,
                pelaporanLhTw4,
              ],
            },
            akumulasi: [tw1, tw2, tw3, tw4],
            akumulasi2: [
              bobotTw1.value ? (tw1 / bobotTw1.value) * 100 : '-',
              bobotTw2.value ? (tw2 / bobotTw2.value) * 100 : '-',
              bobotTw3.value ? (tw3 / bobotTw3.value) * 100 : '-',
              bobotTw4.value ? (tw4 / bobotTw4.value) * 100 : '-',
            ],
          }
        }
      }

      item.toggleDetails()
    }

    const clickPrintXl = async () => {
      try {
        isPrint.value = true

        // window.open(
        //   `https://jakaset.jakarta.go.id/${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/list-summary?filter_kib=C&filter_upd=${pdUpdFilter.value}&kd_wilayah=${wilayahFilter.value}&length=1000000`,
        //   "_blank"
        // );

        const params = {
          filter_ukpd: pdUpdFilter.value,
          length: 1000000,
          start: 0,
          // search: searchQueryDashboardSummary.value,
          kode_wilayah: wilayahFilter.value,
        }
        const resPerkin = await apiPerkin.getListPerkin(g, params)
        const { code, data } = resPerkin

        const kolomXl = [
          ['No', 'Kolok', 'Nalok', 'Individu', '', '', '', 'Gabungan'],
          [
            '',
            '',
            '',
            'TW1 (N/A)',
            'TW2 (10%)',
            'TW3 (55%)',
            'TW4 (100%)',
            'TW1 (N/A)',
            'TW2 (10%)',
            'TW3 (55%)',
            'TW4 (100%)',
          ],
        ]
        if (code == 200) {
          let tw1 = 0
          let tw2 = 0
          let tw3 = 0
          let tw4 = 0
          let tw1Detail = ''
          let tw2Detail = ''
          let tw3Detail = ''
          let tw4Detail = ''

          let no = 1
          // await data.forEach(async (item) => {
          for (let i = 0; i < data.length; i++) {
            const item = data[i]
            tw1 = 0
            tw2 = 0
            tw3 = 0
            tw4 = 0

            tw1Detail = ''
            tw2Detail = ''
            tw3Detail = ''
            tw4Detail = ''

            if (item.persiapanTimTw1 == 1) tw1 += 5
            if (item.persiapanTimTw2 == 1) tw2 += 5
            if (item.persiapanTimTw3 == 1) tw3 += 5
            if (item.persiapanTimTw4 == 1) tw4 += 5

            if (item.persiapanJadwalTw1 == 1) tw1 += 5
            if (item.persiapanJadwalTw2 == 1) tw2 += 5
            if (item.persiapanJadwalTw3 == 1) tw3 += 5
            if (item.persiapanJadwalTw4 == 1) tw4 += 5

            tw1 += (item.hasilSensusTw1 / item.jumlahBmd) * 75
            tw2 += (item.hasilSensusTw2 / item.jumlahBmd) * 75
            tw3 += (item.hasilSensusTw3 / item.jumlahBmd) * 75
            tw4 += (item.hasilSensusTw4 / item.jumlahBmd) * 75

            if (item.pelaporanBaTw1 == 1) tw1 += 5
            if (item.pelaporanBaTw2 == 1) tw2 += 5
            if (item.pelaporanBaTw3 == 1) tw3 += 5
            if (item.pelaporanBaTw4 == 1) tw4 += 5

            if (item.pelaporanSptjmTw1 == 1) tw1 += 5
            if (item.pelaporanSptjmTw2 == 1) tw2 += 5
            if (item.pelaporanSptjmTw3 == 1) tw3 += 5
            if (item.pelaporanSptjmTw4 == 1) tw4 += 5

            if (item.pelaporanLhTw1 == 1) tw1 += 5
            if (item.pelaporanLhTw2 == 1) tw2 += 5
            if (item.pelaporanLhTw3 == 1) tw3 += 5
            if (item.pelaporanLhTw4 == 1) tw4 += 5

            if (item.tipeKolok == 'SKPD') {
              const paramsDetail = {
                filter_upd: item.kolok,
                length: 10000,
                start: 0,
              }
              const resPerkin = await apiPerkin.getListPerkin(g, paramsDetail)
              const { totalData } = resPerkin
              const codeDetail = resPerkin.code
              const dataDetail = resPerkin.data

              if (codeDetail == 200) {
                let persiapanTimTw1 = 0
                let persiapanTimTw2 = 0
                let persiapanTimTw3 = 0
                let persiapanTimTw4 = 0

                let persiapanJadwalTw1 = 0
                let persiapanJadwalTw2 = 0
                let persiapanJadwalTw3 = 0
                let persiapanJadwalTw4 = 0

                let pelaksanaanSelesaiTw1 = 0
                let pelaksanaanSelesaiTw2 = 0
                let pelaksanaanSelesaiTw3 = 0
                let pelaksanaanSelesaiTw4 = 0

                let pelaksanaanBobotTw1 = 0
                let pelaksanaanBobotTw2 = 0
                let pelaksanaanBobotTw3 = 0
                let pelaksanaanBobotTw4 = 0

                let jumlahBmd = 0

                let pelaporanBaTw1 = 0
                let pelaporanBaTw2 = 0
                let pelaporanBaTw3 = 0
                let pelaporanBaTw4 = 0

                let pelaporanSptjmTw1 = 0
                let pelaporanSptjmTw2 = 0
                let pelaporanSptjmTw3 = 0
                let pelaporanSptjmTw4 = 0

                let pelaporanLhTw1 = 0
                let pelaporanLhTw2 = 0
                let pelaporanLhTw3 = 0
                let pelaporanLhTw4 = 0

                tw1Detail = 0
                tw2Detail = 0
                tw3Detail = 0
                tw4Detail = 0

                for (let i = 0; i < dataDetail.length; i++) {
                  const itemDetail = dataDetail[i]
                  if (itemDetail.persiapanTimTw1 == 1) persiapanTimTw1 += 5
                  if (itemDetail.persiapanTimTw2 == 1) persiapanTimTw2 += 5
                  if (itemDetail.persiapanTimTw3 == 1) persiapanTimTw3 += 5
                  if (itemDetail.persiapanTimTw4 == 1) persiapanTimTw4 += 5

                  if (itemDetail.persiapanJadwalTw1 == 1) { persiapanJadwalTw1 += 5 }
                  if (itemDetail.persiapanJadwalTw2 == 1) { persiapanJadwalTw2 += 5 }
                  if (itemDetail.persiapanJadwalTw3 == 1) { persiapanJadwalTw3 += 5 }
                  if (itemDetail.persiapanJadwalTw4 == 1) { persiapanJadwalTw4 += 5 }

                  pelaksanaanSelesaiTw1 += parseInt(itemDetail.hasilSensusTw1)
                  pelaksanaanSelesaiTw2 += parseInt(itemDetail.hasilSensusTw2)
                  pelaksanaanSelesaiTw3 += parseInt(itemDetail.hasilSensusTw3)
                  pelaksanaanSelesaiTw4 += parseInt(itemDetail.hasilSensusTw4)

                  jumlahBmd += parseInt(itemDetail.jumlahBmd)

                  if (itemDetail.pelaporanBaTw1 == 1) pelaporanBaTw1 += 5
                  if (itemDetail.pelaporanBaTw2 == 1) pelaporanBaTw2 += 5
                  if (itemDetail.pelaporanBaTw3 == 1) pelaporanBaTw3 += 5
                  if (itemDetail.pelaporanBaTw4 == 1) pelaporanBaTw4 += 5

                  if (itemDetail.pelaporanSptjmTw1 == 1) pelaporanSptjmTw1 += 5
                  if (itemDetail.pelaporanSptjmTw2 == 1) pelaporanSptjmTw2 += 5
                  if (itemDetail.pelaporanSptjmTw3 == 1) pelaporanSptjmTw3 += 5
                  if (itemDetail.pelaporanSptjmTw4 == 1) pelaporanSptjmTw4 += 5

                  if (itemDetail.pelaporanLhTw1 == 1) pelaporanLhTw1 += 5
                  if (itemDetail.pelaporanLhTw2 == 1) pelaporanLhTw2 += 5
                  if (itemDetail.pelaporanLhTw3 == 1) pelaporanLhTw3 += 5
                  if (itemDetail.pelaporanLhTw4 == 1) pelaporanLhTw4 += 5
                }

                persiapanTimTw1 = Math.round((persiapanTimTw1 / totalData) * 100) / 100
                persiapanTimTw2 = Math.round((persiapanTimTw2 / totalData) * 100) / 100
                persiapanTimTw3 = Math.round((persiapanTimTw3 / totalData) * 100) / 100
                persiapanTimTw4 = Math.round((persiapanTimTw4 / totalData) * 100) / 100

                persiapanJadwalTw1 = Math.round((persiapanJadwalTw1 / totalData) * 100) / 100
                persiapanJadwalTw2 = Math.round((persiapanJadwalTw2 / totalData) * 100) / 100
                persiapanJadwalTw3 = Math.round((persiapanJadwalTw3 / totalData) * 100) / 100
                persiapanJadwalTw4 = Math.round((persiapanJadwalTw4 / totalData) * 100) / 100

                pelaksanaanBobotTw1 = Math.round((pelaksanaanSelesaiTw1 / jumlahBmd) * 75 * 100)
                  / 100
                pelaksanaanBobotTw2 = Math.round((pelaksanaanSelesaiTw2 / jumlahBmd) * 75 * 100)
                  / 100
                pelaksanaanBobotTw3 = Math.round((pelaksanaanSelesaiTw3 / jumlahBmd) * 75 * 100)
                  / 100
                pelaksanaanBobotTw4 = Math.round((pelaksanaanSelesaiTw4 / jumlahBmd) * 75 * 100)
                  / 100

                pelaporanBaTw1 = Math.round((pelaporanBaTw1 / totalData) * 100) / 100
                pelaporanBaTw2 = Math.round((pelaporanBaTw2 / totalData) * 100) / 100
                pelaporanBaTw3 = Math.round((pelaporanBaTw3 / totalData) * 100) / 100
                pelaporanBaTw4 = Math.round((pelaporanBaTw4 / totalData) * 100) / 100

                pelaporanSptjmTw1 = Math.round((pelaporanSptjmTw1 / totalData) * 100) / 100
                pelaporanSptjmTw2 = Math.round((pelaporanSptjmTw2 / totalData) * 100) / 100
                pelaporanSptjmTw3 = Math.round((pelaporanSptjmTw3 / totalData) * 100) / 100
                pelaporanSptjmTw4 = Math.round((pelaporanSptjmTw4 / totalData) * 100) / 100

                pelaporanLhTw1 = Math.round((pelaporanLhTw1 / totalData) * 100) / 100
                pelaporanLhTw2 = Math.round((pelaporanLhTw2 / totalData) * 100) / 100
                pelaporanLhTw3 = Math.round((pelaporanLhTw3 / totalData) * 100) / 100
                pelaporanLhTw4 = Math.round((pelaporanLhTw4 / totalData) * 100) / 100

                tw1Detail = Math.round(
                  (persiapanTimTw1
                      + persiapanJadwalTw1
                      + pelaksanaanBobotTw1
                      + pelaporanBaTw1
                      + pelaporanSptjmTw1
                      + pelaporanLhTw1)
                      * 100,
                ) / 100
                tw2Detail = Math.round(
                  (persiapanTimTw2
                      + persiapanJadwalTw2
                      + pelaksanaanBobotTw2
                      + pelaporanBaTw2
                      + pelaporanSptjmTw2
                      + pelaporanLhTw2)
                      * 100,
                ) / 100
                tw3Detail = Math.round(
                  (persiapanTimTw3
                      + persiapanJadwalTw3
                      + pelaksanaanBobotTw3
                      + pelaporanBaTw3
                      + pelaporanSptjmTw3
                      + pelaporanLhTw3)
                      * 100,
                ) / 100
                tw4Detail = Math.round(
                  (persiapanTimTw4
                      + persiapanJadwalTw4
                      + pelaksanaanBobotTw4
                      + pelaporanBaTw4
                      + pelaporanSptjmTw4
                      + pelaporanLhTw4)
                      * 100,
                ) / 100
              }

              console.log({
                tw1Detail, tw2Detail, tw3Detail, tw4Detail,
              })
            }

            kolomXl.push([
              no,
              item.kolok,
              item.nalok,
              tw1,
              tw2,
              tw3,
              tw4,
              tw1Detail,
              tw2Detail,
              tw3Detail,
              tw4Detail,
            ])

            no++
          }
        }

        const ws = utils.json_to_sheet([])
        const wb = utils.book_new()
        utils.sheet_add_aoa(ws, kolomXl)
        utils.book_append_sheet(wb, ws, 'Data')
        writeFileXLSX(
          wb,
          `Perkin ${moment().format('DD-MM-YYYY HH:mm:ss')}.xlsx`,
        )
      } catch (error) {
        console.log(error)
        showError(g, { request: error.toString() }, 'Gagal Print Excel')
      }

      isPrint.value = false
    }

    const numThousand = value => intThousand(value)

    dataSummary()
    getWilayah()
    getStatus()
    getPdUpd()

    return {
      isPrint,
      perPage,
      perPageSummary,
      perPageOptions,
      searchQuery,
      searchQueryDashboardSummary,
      dataStatus,
      kolomDetailPerkin,
      statusFilter,
      rows,
      bobotTw1,
      bobotTw2,
      bobotTw3,
      bobotTw4,
      bobotTw1Show,
      bobotTw2Show,
      bobotTw3Show,
      bobotTw4Show,
      dataPerkin,
      kolomTw,
      sortBy,
      isSortDirDesc,
      totalRecords,
      totalRecordsDashboardSummary,
      currentPage,
      currentPageSummary,
      isLoadingChart,
      isShowTabel,
      pdUpdFilterValue,
      pdUpdFilter,
      wilayahFilter,
      tahunFilter,
      dataWilayah,
      dataTahunPelaksanaan,
      dataPdUpd,
      dataPie,
      dataCapaianInventarisasi,
      changeWilayah,
      searchPdUpd,
      inputPdUpd,
      submitFilter,
      keyUpSearchDashboardSummary,
      changePageSummary,
      inputPerPageSummary,
      clickCollapse,
      pieChart,
      numThousand,
      clickPrintXl,
    }
  },
  components: {
    VueApexCharts,
    vSelect,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BButton,
    BForm,
    BFormGroup,
    BFormSelect,
  },
  directives: {
    Ripple,
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
